import { createSelector } from 'reselect';

import type { AppMigrationState } from './types';

export const appMigration = (state: {
  appMigration: AppMigrationState;
}): AppMigrationState => state.appMigration;

export const getIsAppMigrationTopBannerDismissed = createSelector(
  [appMigration],
  (appMigrationState) => appMigrationState.isTopBannerDismissed
);
